<template>
  <div class="message" :class="messageClass">
    <div v-if="source.showTime" class="time">{{ formatTime() }}</div>
    <!-- 文本 -->
    <div v-if="source.type === 1" class="bubble" :class="bubbleClass">
      <div v-for="(text, index) in texts" :key="index">
        <MixedText
          v-if="text"
          :textContent="text"
          @to-send="onSendQuestion"
          @to-link="handleLinkJump"
        ></MixedText>
        <!-- <span v-if="text" v-html="text"></span> -->
        <br v-else />
      </div>
    </div>
    <!-- 文本+图片 -->
    <div v-if="source.type === 11" class="bubble" :class="bubbleClass">
      <!-- 渲染文本 -->
      <span
        v-for="(text, index) in aiReplyText.text"
        :key="'text-' + index"
        style="color: #fff"
      >
        {{ text }}
      </span>

      <!-- 渲染图片 -->
      <div
        v-for="(image, index) in aiReplyText.images"
        :key="'image-' + index"
        @click="onViewImage({ type: 'urlType', url: image })"
      >
        <img
          crossorigin="anonymous"
          :src="image"
          alt="Image"
          style="max-width: 100%; height: auto"
        />
      </div>
      <!-- 点赞/点踩按钮 -->
      <div v-if="source.msgIndex === 0 && showFeedBackIcon">
        <div @click="onClickFeedback('like')">
          <img
            :src="likeImageSrc"
            :class="[
              'bubble',
              'feedback-like',
              { 'like-active': likeFeedBack === 'like' },
            ]"
          />
        </div>
        <div @click="onClickFeedback('unlike')">
          <img
            :src="unlikeImageSrc"
            :class="[
              'bubble',
              'feedback-unlike',
              { 'unlike-active': likeFeedBack === 'unlike' },
            ]"
          />
        </div>
      </div>
    </div>

    <!-- 订单咨询 -->
    <OrderCard
      v-else-if="source.type === 9"
      class="bubble"
      :class="bubbleClass"
      :data="source"
    />
    <div v-else-if="source.type === 7" class="bubble" :class="bubbleClass">
      <div>
        <div>
          {{ formContent.text }}
        </div>
        <button class="message-btn" @click="onClickUploadDrafts()">
          {{ formContent.btnText }}
        </button>
      </div>
    </div>
    <!-- 文字列表 -->
    <div v-else-if="source.type === 4" class="text-list">
      <div class="question-box">
        <div
          v-for="(item, index) in textList"
          :key="item"
          class="question"
          @click="onSendQuestion(item)"
        >
          <span>{{ index + 1 }}.{{ item }}</span>
        </div>
      </div>
      <div
        v-if="source.showHelp"
        class="bubble left text-left help"
        :class="{ 'can-click': !clickedNoHelp }"
        @click="onClickHelp"
      >
        {{ $t("noIssue") }}
      </div>
    </div>
    <!-- 选项列表 -->
    <div v-else-if="source.type === 8" class="question-list">
      <div class="question-box">
        <div class="question-description" v-if="source.description">
          {{ source.description }}
        </div>
        <div
          v-for="(item, index) in textList"
          :key="item"
          class="question"
          @click="onSendOptionQuestion(item)"
        >
          <div>
            <span> {{ item }}</span
            ><img src="@/assets/img/feedback/arrow_right.png" />
          </div>
        </div>
      </div>
    </div>
    <!-- 意见反馈 -->
    <Card v-else-if="source.type === 5" />
    <!-- 图片 -->
    <div
      v-else-if="source.type === 2"
      class="bubble image-box"
      :style="imageBoxStyle"
      @click="
        onViewImage({
          type: 'image',
        })
      "
    >
      <img :src="source.content" :style="imageStyle" />
    </div>
    <!-- 意见反馈 -->
    <RefundCard
      v-else-if="source.type === MessageType.refundCard"
      :data="source"
      :post="post"
    />
    <!-- 视频 -->
    <div
      v-else-if="source.type === 3"
      ref="videoImg"
      class="bubble video-box"
      :style="videoBoxStyle"
      @click="onClickVideo"
    >
      <van-loading
        v-if="!posterStatus"
        style="
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
      </van-loading>
      <template v-else-if="posterStatus === 1">
        <!-- h5 video 有兼容问题，ios封面也加载出不来，这个不是用video标签 -->
        <img
          :style="{ width: `${videoSize.w}px`, height: `${videoSize.h}px` }"
          :src="poster"
        />
        <img class="play-icon" src="@/assets/img/feedback/play.png" />
      </template>
      <div style="z-index: inherit" class="poster" v-else>
        <span
          style="
            color: #fff;
            position: absolute;
            left: 0.5em;
            bottom: 0.5em;
            font-size: 0.16rem;
          "
          >{{ computedVideoDuration }}</span
        >
        <img class="play-icon" src="@/assets/img/feedback/play.png" />
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import EventBus from "@/utils/event-bus";
import { rem2px } from "@/utils/formatter";
import MixedText from "./mixedText";
import Card from "./card";
import RefundCard from "./RefundCard";
import kylogger from "@ky/sdk/dist/log/kylogger";
import OrderCard from "./orderCard";
import { MessageType } from "@/utils/constant";
import { showToast } from "vant";
import device from "@/utils/device";

dayjs.extend(isSameOrAfter);

export default {
  name: "Message",
  components: {
    Card,
    MixedText,
    OrderCard,
    RefundCard,
  },
  props: {
    source: {
      type: Object,
      required: true,
    },
    noHelpedList: {
      type: Array,
      default: () => [],
    },
    post: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      poster: "",
      isPlaying: false,
      playCount: 0,
      posterStatus: 0,
      videoDuration: 0,
      likeFeedBack: "init",
      showFeedBackIcon: true,
      formContent: {
        text: "",
        btnText: "",
        btnUrl: "",
      },
      isOverseas: process.env.CODE_ENV === "spg",
    };
  },
  computed: {
    isUserMsg() {
      // source 1用户 2自动回复 3客服回复
      return this.source.source === 1;
    },
    messageClass() {
      const arr = [];
      arr.push(this.isUserMsg ? "right" : "left");
      return arr;
    },
    bubbleClass() {
      const arr = [];
      if (
        this.source.type === 1 ||
        this.source.type === 7 ||
        this.source.type === 9 ||
        this.source.type === 11
      ) {
        arr.push(this.isUserMsg ? "text-right" : "text-left");
      }
      return arr;
    },
    texts() {
      if (this.source.type === 1) {
        const { content = "" } = this.source;
        return content.split("\n").map((item) => this.strToLink(item));
      }
      return [];
    },
    textList() {
      if (this.source.type === 4 || this.source.type === 8) {
        return this.source.content.split(";");
      }
      return [];
    },
    // 点赞图片的动态路径
    likeImageSrc() {
      if (this.likeFeedBack === "like") {
        return "https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/like_red.png";
      }
      return "https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/like.png";
    },
    // 点踩图片的动态路径
    unlikeImageSrc() {
      if (this.likeFeedBack === "unlike") {
        return "https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/like_red.png";
      }
      return "https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/like.png";
    },
    aiReplyText() {
      if (this.source.type === 11) {
        const content = this.source.content;
        // 1. 提取文本部分，去掉图片占位符
        const text = content.replace(/!\[.*?\]\(https?:\/\/.*?\)/g, "").trim(); // 去掉所有格式为 ![标题文案](https://...) 的图片链接占位符

        // 2. 提取图片链接
        const imageRegex = /!\[.*?\]\((https?:\/\/.*?)\)/g; // 正则表达式匹配所有形如 ![标题文案](https://...) 的图片
        const images = [];
        let match;

        // 提取所有图片链接
        while ((match = imageRegex.exec(content)) !== null) {
          images.push(match[1]); // match[1] 是捕获到的图片 URL
        }

        return {
          text, // 纯文本部分
          images, // 提取的图片链接部分
        };
      }
      return { text: "", images: [] }; // 如果不是 type 11，返回空文本和图片数组
    },

    imageSize() {
      let extra = this.source.extra;
      try {
        extra = JSON.parse(extra);
      } catch (e) {
        extra = {};
      }
      const baseW = rem2px(1.6);
      const baseHorizontalW = rem2px(3.46);
      const minW = rem2px(0.6);
      const width = extra.w || baseW;
      const height = extra.h || baseW;
      if (height >= width) {
        const w = width < baseW ? Math.max(width, minW) : baseW;
        const h = (height / width) * w;
        return { w, h, boxW: w, boxH: h };
      }
      const w =
        width < baseHorizontalW ? Math.max(width, minW) : baseHorizontalW;
      const h = (height / width) * w;
      return { w, h, boxW: w, boxH: h };
    },
    imageStyle() {
      const { w, h } = this.imageSize;
      return { width: `${w}px`, height: `${h}px` };
    },
    imageBoxStyle() {
      const { boxW, boxH } = this.imageSize;
      return { width: `${boxW + 2}px`, height: `${boxH + 2}px` };
    },
    videoSize() {
      let extra = this.source.extra;
      try {
        extra = JSON.parse(extra);
      } catch (e) {
        extra = {};
      }
      const baseW = rem2px(3.5);
      const width = extra.w || baseW;
      const height = extra.h || baseW * 1.5;
      const h = (height / width) * baseW;
      return { w: baseW, h };
    },
    videoBoxStyle() {
      const { w, h } = this.videoSize;
      return { width: `${w + 2}px`, height: `${h + 2}px` };
    },
    videoType() {
      let suffix = "mp4";
      const { type, content } = this.source;
      if (type === 3) {
        const matched = content.match(/\.(\w+)?$/);
        if (matched) {
          suffix = matched[1];
        }
      }
      if (suffix === "quicktime") {
        suffix = "mp4";
      }
      return `video/${suffix}`;
    },
    clickedNoHelp() {
      return (
        this.noHelpedList.includes(this.source.id) || this.source.help === 2
      );
    },
    computedVideoDuration() {
      return durationToSecond((this.videoDuration ?? 0) * 1000);
    },
  },
  mounted() {
    this.messageBtn();
    this.setPoster();
    if (this.source.type === 8) {
      kylogger.collect("SHOW", "QUESTIONNAIRE_REPLY", {
        message_id: this.source.id,
      });
    }
  },
  methods: {
    handleLinkJump(url) {
      window.kwaiying?.open(JSON.stringify({ url }));
    },

    messageBtn() {
      if (this.source.type === 7) {
        this.formContent = JSON.parse(this.source.content);
      }
    },
    onClickVideo() {
      if (device.isHarmony) {
        const video = this.$refs.video;
        if (this.isPlaying) {
          video.pause();
        } else if (this.source.content.endsWith("3gp")) {
          // Toast('不支持该视频格式')
        } else {
          if (video.requestFullscreen) {
            video.requestFullscreen();
          } else if (video.mozRequestFullScreen) {
            video.mozRequestFullScreen();
          } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
          } else if (video.msRequestFullscreen) {
            video.msRequestFullscreen();
          }
          video.play();
        }
        return;
      }
      const url = `kwaiying://krn?bundleId=profile&componentName=template-preview&videoPath=${this.source.content}`;
      window.callback = function () {
        delete window.callback;
      };
      window.kwaiying.open(
        JSON.stringify({
          url,
          callback: "callback",
        }),
      );
    },
    setPoster() {
      if (this.source.type !== 3) return;
      this.posterStatus = 0;
      this.getPosterFromVideo({
        width: this.videoSize.w,
        height: this.videoSize.h,
        src: this.source.content,
      })
        .then((url) => {
          this.poster = url;
          this.posterStatus = 1;
        })
        .catch((e) => {
          this.posterStatus = 2;
          console.log(e);
        });
    },
    /** 从视频中提取封面 */
    getPosterFromVideo({ width = 0, height = 0, src, video }) {
      return new Promise((resolve, reject) => {
        const video = document.createElement("video");
        video.setAttribute("crossOrigin", "anonymous");
        video.setAttribute("muted", "muted"); // 静音操作，防止播放失败
        video.setAttribute("preload", "auto");
        video.setAttribute("width", width);
        video.setAttribute("width", height);
        video.setAttribute("autoplay", true);
        video.setAttribute("x5-video-player-type", "h5");
        video.setAttribute("x5-video-player-fullscreen", true);
        video.setAttribute("playsinline", true);
        video.setAttribute("webkit-playsinline", true);
        video.setAttribute("src", src);
        video.onloadedmetadata = () => {
          video.oncanplaythrough = () => {
            const duration = video.duration;
            try {
              video.currentTime = 1;
              const canvas = document.createElement("canvas");
              canvas.width = width;
              canvas.height = height;
              canvas
                .getContext("2d")
                .drawImage(video, 0, 0, canvas.width, canvas.height);
              const imgUrl = canvas.toDataURL("image/png");
              video.currentTime = 0;
              video.setAttribute("autoplay", false);
              video.pause();
              resolve(imgUrl);
              throw new Error();
            } catch {
              this.videoDuration = duration;
              reject();
            }
          };
        };
        video.onerror = reject;
      });
    },
    onPause() {
      this.isPlaying = false;
    },
    onPlay() {
      this.playCount++;
      this.isPlaying = true;
    },
    formatTime() {
      const ts = this.source.createTime;
      const now = dayjs().format("YYYY-MM-DD");
      const tsDate = dayjs(ts).format("YYYY-MM-DD");
      if (dayjs(tsDate).isSameOrAfter(now)) {
        return dayjs(ts).format("HH:mm");
      }
      return dayjs(ts).format("YYYY-MM-DD HH:mm");
    },
    onSendQuestion(item) {
      EventBus.$emit("send-question", item);
    },
    onSendOptionQuestion(item) {
      kylogger.collect("CLICK", "QUESTIONNAIRE_REPLY", {
        message_id: this.source.id,
        option_content: item,
        option_id: "",
      });
      EventBus.$emit("send-question", item);
    },
    onViewImage({ type = "image", url = "" }) {
      if (type === "image") {
        EventBus.$emit("view-image", this.source, "image");
      } else if (type === "urlType" && url !== "") {
        EventBus.$emit("view-image", url, "urlType");
      }
    },
    onClickHelp() {
      if (!this.clickedNoHelp) {
        EventBus.$emit("no-help", this.source);
      }
    },
    onClickUploadDrafts() {
      console.log("上传草稿popup", this.formContent.btnUrl);
      window.open(this.formContent.btnUrl);
    },
    onClickFeedback(type) {
      if (this.likeFeedBack === type) return;
      kylogger.collect("CLICK", "CLICK_FEEDBACK", {
        feedback_type: type,
        message_id: this.source.id,
        source_type: this.source.type,
        message_content: this.source.content,
      });
      setTimeout(() => {
        this.showFeedBackIcon = false;
      }, 2000);
      showToast({
        message:
          '<div style="justify-content: center; padding:0.22rem 0.4rem;color:rgba(255,255,255,0.9);font-size: 0.26rem; border-width:0.5px; border-style: solid; border-color: rgba(255,255,255,0.08);background-color: rgba(34,34,34,0.95);border-radius: 16rem;">感谢您的反馈</div>',
        type: "html",
      });
      this.likeFeedBack = type;
    },
    strToLink(preStr) {
      const chineseReg =
        /[\u4E00-\u9FFF]|[\u3400-\u4DBF]|[\u{20000}-\u{2A6DF}]|[\u{2A700}-\u{2B73F}]|[\u{2B740}-\u{2B81F}]|[\u{2B820}-\u{2CEAF}]|[\uF900-\uFAFF]|[\u3300-\u33FF]|[\uFE30-\uFE4F]|[\uF900-\uFAFF]|[\u{2F800}-\u{2FA1F}]/gu;
      const spaceStr = preStr.replace(chineseReg, function (a) {
        return " " + a + " ";
      });
      // /(((https?:\/\/)|(www\.))[^\s]+)/g

      const reg = /(((https?:\/\/)|(@@https?:\/\/)|(www\.))[^\s]+)/g;

      //  /(^|[^@])(http:\/\/|https:\/\/|www\.)[^\s]+/g
      //  /((?<!@@)((https?:\/\/)|(www\.))[^\s]+)/g
      const str = spaceStr.replace(reg, function (a) {
        if (a.startsWith("@@")) {
          return a;
        }
        const href = a.startsWith("http") ? "" : "https://";
        return "@@" + href + a + "|" + href + a + "@@";
        // return '<<<a target="__blank" href="' + href + a + '">' + a + '</a><<'
      });
      const strArr = str.split("<<");
      const newStr = strArr
        .map((item) => {
          if (item.startsWith("<")) {
            return item;
          }

          return item.replace(/\s/g, this.isOverseas ? " " : "");
        })
        .join("");
      return newStr;
    },
  },
};
</script>
<style lang="less" scoped>
.message {
  display: flex;
  flex-direction: column;
  // font-size: 0.3rem;
  font-size: 0.26rem;

  .bubble {
    margin-top: 0.32rem;
    border-radius: 0.4rem;
    overflow: hidden;
    overflow-wrap: break-word;
    word-wrap: break-word;
    box-sizing: border-box;
    &.text-left {
      max-width: 80%;
      // padding: 0.29rem 0.29rem;
      padding: 0.4rem 0.32rem;
      // background-color: rgba(0, 0, 0, 0.03);
      background-color: #222;
      // color: rgba(0, 0, 0, 0.9);
      color: rgba(255, 255, 255, 0.9);
      border-top-left-radius: 0.1rem;
      text-align: justify;
    }

    .message-btn {
      background: linear-gradient(
        135deg,
        #f52c6f 0%,
        #f7365d 49.58%,
        #ff5151 100%
      );
      border-radius: 0.5rem;
      border: 0;
      height: 0.6rem;
      width: 2.08rem;
      font-size: 0.24rem;
      color: rgba(255, 255, 255, 0.9);
      font-weight: 600;
      margin-top: 0.24rem;
    }

    .text-title {
      font-size: 0.3rem;
      font-weight: 600;
      color: rgba(255, 255, 255, 0.9);
      line-height: 120%;
      text-align: justify;
    }

    .text-content {
      font-size: 0.26rem;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.9);
      line-height: 150%;
      margin-top: 0.16rem;
      text-align: justify;
    }

    &.text-right {
      max-width: 85%;
      // padding: 0.2rem 0.29rem;
      padding: 0.32rem;
      background-color: #289afd;
      color: rgba(255, 255, 255, 1);
      border-top-right-radius: 0.1rem;
      text-align: justify;
    }

    &.image-box {
      padding: 0;
      border: solid 1px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
    }

    &.video-box {
      padding: 0;
      position: relative;
      border: solid 1px rgba(0, 0, 0, 0.1);
      border-radius: 8px;

      .poster {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9;
        background-color: rgba(0, 0, 0, 1);
      }

      .play-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 0.6rem;
        height: 0.6rem;
        z-index: 99;
      }
    }
    &.feedback-like {
      position: absolute;
      right: 20%;
      width: 0.3rem;
      height: 0.3rem;
      &.like-active {
        transform: rotate(180deg);
      }
    }
    &.feedback-unlike {
      position: absolute;
      transform: rotate(180deg);
      right: 15%;
      width: 0.3rem;
      height: 0.3rem;
      &.unlike-active {
        transform: rotate(0deg);
      }
    }
  }

  &.left {
    .bubble {
      align-self: flex-start;
    }
  }

  &.right {
    .bubble {
      align-self: flex-end;
    }
  }

  .text-list {
    display: flex;
    flex-direction: column;
    font-size: 0.26rem;
    // color: rgba(53, 131, 255, 1);
    color: #6eafcc;

    .question-box {
      margin-top: 0.32rem;
      width: 80%;
      border-radius: 0.4rem;
      border-top-left-radius: 0.1rem;
      // background-color: rgba(0, 0, 0, 0.03);
      background: #222;
      padding: 0.4rem 0.32rem;

      .question-description {
        font-size: 0.28rem;
        color: rgba(255, 255, 255, 0.9);
        line-height: 120%;
        margin-bottom: 0.26rem;
      }

      .question {
        // padding: 0 0.28rem;
        & > span {
          position: relative;
          display: block;
          // padding: 0.19rem 0;
          padding-bottom: 0.24rem;
          line-height: 0.4rem;
          // &::before {
          //   position: absolute;
          //   bottom: 0;
          //   content: ' ';
          //   width: 100%;
          //   height: 20px;
          //   // height: 0.44rem;
          //   // transform: scaleY(0.5);
          //   background-color: rgba(0, 0, 0, 0.1);
          // }
        }

        &:last-child > span {
          padding-bottom: 0;
          // &::before {
          //   position: absolute;
          //   bottom: 0;
          //   content: ' ';
          //   width: 100%;
          //   height: 0;
          // }
        }
      }
    }

    .help {
      color: rgba(0, 0, 0, 0.5);

      &.can-click {
        color: rgba(53, 131, 255, 1);
      }
    }
  }

  .question-list {
    display: flex;
    flex-direction: column;
    font-size: 0.26rem;
    // color: rgba(53, 131, 255, 1);
    color: rgba(255, 255, 255, 0.9);

    // color: #6eafcc;
    .question-box {
      margin-top: 0.32rem;
      width: 80%;
      border-radius: 0.4rem;
      border-top-left-radius: 0.1rem;
      // background-color: rgba(0, 0, 0, 0.03);
      background: #222;
      padding: 0.32rem 0.4rem;

      .question-description {
        font-size: 0.26rem;
        color: rgba(255, 255, 255, 0.9);
        line-height: 120%;
        margin-bottom: 0.16rem;
      }

      .question {
        // padding: 0 0.28rem;
        & > div {
          position: relative;
          margin: 0.16rem 0;
          padding: 0.24rem;
          background: rgba(255, 255, 255, 0.04);
          border-radius: 0.16rem;
          justify-content: space-between;
          align-items: center;
          display: flex;

          & > img {
            width: 0.32rem;
            height: 0.32rem;
          }
        }

        &:last-child > div {
          margin-bottom: 0;
        }
      }
    }

    .help {
      color: rgba(0, 0, 0, 0.5);

      &.can-click {
        color: rgba(53, 131, 255, 1);
      }
    }
  }

  img {
    display: block;
  }

  video {
    display: block;
  }

  .time {
    display: flex;
    justify-content: center;
    margin-top: 0.32rem;
    // color: rgba(0, 0, 0, 0.5);
    color: #7f7f7f;
    font-size: 0.22rem;
  }
}
</style>
